import { Box, styled } from '@ltvco/refresh-lib/theme';

export const ChatSearchContainer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== '$fixedWidth',
})<{ $fixedWidth?: string }>(({ $fixedWidth }: { $fixedWidth?: string }) =>
  $fixedWidth
    ? {
        flexGrow: 0,
        flexShrink: 0,
        width: $fixedWidth,
        minWidth: $fixedWidth,
        maxWidth: $fixedWidth,
        display: 'flex',
        overflow: 'hidden',
        '& > *': {
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
        },
        '& > * > .MuiTextField-root, & [data-testid="bbq-search-input"]': {
          flex: '1 1 0%',
          minWidth: 0,
          maxWidth: '100%',
        },
        '& .MuiOutlinedInput-root': {
          width: '100% !important',
          maxWidth: '100% !important',
          minWidth: '0 !important',
        },
        '& > * > button': {
          flexShrink: 0,
        },
      }
    : {
        width: '100%',
        minWidth: 0,
        display: 'flex',
        '@media (min-width: 1025px)': {
          flex: '1 1 0%',
          width: 'auto',
          maxWidth: 'none',
        },
        '& > *': {
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
        },
        '& > * > .MuiTextField-root, & [data-testid="bbq-search-input"]': {
          flex: '1 1 0%',
          minWidth: 0,
          maxWidth: '100%',
        },
        '& .MuiOutlinedInput-root': {
          width: '100% !important',
          minWidth: '0 !important',
        },
      }
);
